import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private loginUrl: string;

  constructor(private http:HttpClient, private globals:Globals, private env:EnvService) { this.loginUrl = this.env.servicePath; }

  createMenuCard():Observable<string>{
    var path = this.loginUrl +"CreateMenuCard";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  selectMenuCardMenuAction(id: string, actionName:string):Observable<string>{
    var path = this.loginUrl +"SelectMenuCardMenuAction/"+id + "/" + actionName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getMenuCardMenuActions(id:string):Observable<string>{
    var path = this.loginUrl +"GetMenuCardMenuActions/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }
}
